/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPrediction = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m22.485 3-2.121 2.121-1.414-1.414 2.121-2.121zM4 10.586V2H2v20h20v-2h-2v-3.5h-2V20h-2v-5h-2v5h-2v-7h-2v7H8v-6H6v6H4v-6.586l5.993-5.992 2.723 2.778 1.283 1.286 2.122-2.122-1.414-1.414-.705.705-3.995-4.076zm13.89-5.818 1.413 1.414-2.121 2.121-1.414-1.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPrediction as Prediction };
